module.exports = __webpack_public_path__ + "static/img/camera.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/camera.png
// module id = 526
// module chunks = 0